// While filters are precompiled, pseudos get called when they are needed
export const pseudos = {
  empty(elem, _ref) {
    let {
      adapter
    } = _ref;
    return !adapter.getChildren(elem).some(elem =>
    // FIXME: `getText` call is potentially expensive.
    adapter.isTag(elem) || adapter.getText(elem) !== "");
  },
  "first-child"(elem, _ref2) {
    let {
      adapter,
      equals
    } = _ref2;
    if (adapter.prevElementSibling) {
      return adapter.prevElementSibling(elem) == null;
    }
    const firstChild = adapter.getSiblings(elem).find(elem => adapter.isTag(elem));
    return firstChild != null && equals(elem, firstChild);
  },
  "last-child"(elem, _ref3) {
    let {
      adapter,
      equals
    } = _ref3;
    const siblings = adapter.getSiblings(elem);
    for (let i = siblings.length - 1; i >= 0; i--) {
      if (equals(elem, siblings[i])) return true;
      if (adapter.isTag(siblings[i])) break;
    }
    return false;
  },
  "first-of-type"(elem, _ref4) {
    let {
      adapter,
      equals
    } = _ref4;
    const siblings = adapter.getSiblings(elem);
    const elemName = adapter.getName(elem);
    for (let i = 0; i < siblings.length; i++) {
      const currentSibling = siblings[i];
      if (equals(elem, currentSibling)) return true;
      if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
        break;
      }
    }
    return false;
  },
  "last-of-type"(elem, _ref5) {
    let {
      adapter,
      equals
    } = _ref5;
    const siblings = adapter.getSiblings(elem);
    const elemName = adapter.getName(elem);
    for (let i = siblings.length - 1; i >= 0; i--) {
      const currentSibling = siblings[i];
      if (equals(elem, currentSibling)) return true;
      if (adapter.isTag(currentSibling) && adapter.getName(currentSibling) === elemName) {
        break;
      }
    }
    return false;
  },
  "only-of-type"(elem, _ref6) {
    let {
      adapter,
      equals
    } = _ref6;
    const elemName = adapter.getName(elem);
    return adapter.getSiblings(elem).every(sibling => equals(elem, sibling) || !adapter.isTag(sibling) || adapter.getName(sibling) !== elemName);
  },
  "only-child"(elem, _ref7) {
    let {
      adapter,
      equals
    } = _ref7;
    return adapter.getSiblings(elem).every(sibling => equals(elem, sibling) || !adapter.isTag(sibling));
  }
};
export function verifyPseudoArgs(func, name, subselect, argIndex) {
  if (subselect === null) {
    if (func.length > argIndex) {
      throw new Error(`Pseudo-class :${name} requires an argument`);
    }
  } else if (func.length === argIndex) {
    throw new Error(`Pseudo-class :${name} doesn't have any arguments`);
  }
}